<template>
  <div> 
    <!-- <Modal class="verify-modal-wrapper" v-model="showModal"  :closable="false"  title="拖动下方滑块完成验证">
       
  </Modal> -->
  <el-dialog class="verify-modal-wrapper"  :custom-class="'verify-dialog'"
  :close-on-click-modal="false" :modal-append-to-body="false" :visible.sync="showModal" title="拖动下方滑块完成验证" :before-close="handleClose" width="520px" >
    <div :id="id" class="nc-container"></div>
            <div slot="footer"></div>
  </el-dialog>
  </div>
  
</template>

<script>
import '@/utils/ncpc'

export default {
  name: 'VerifyModal',
  props: {
    id: {
      type: String,
      default: 'slide-bar'
    },
  },

  data () {
    return {
      showModal: false,
      scene: '',
    }
  },
  mounted () {
  
  },
  methods: {
    invokeModal () {
      this.showModal = true
      this.$nextTick(() => {
        this.initNoCaptcha()
          this.nc.reload()
        })
    },
    initNoCaptcha () {
      const _that = this
      const ncToken = ['FFFF0N1N0000000094C1', (new Date()).getTime(), Math.random()].join(':')
      _that.nc = new noCaptcha({ // eslint-disable-line
        renderTo: this.id,
        appkey: 'FFFF0N1N0000000094C1',
        scene: 'nc_login',
        token: ncToken,
        customWidth: 320,
        callback: function (data) {
          const aliParam = {
            token: ncToken,
            sessionId: data.csessionid,
            sig: data.sig,
            scene: this.scene || 'nc_login'
          }
          setTimeout(() => {
            _that.showModal = false
            _that.$emit('success', aliParam)
          }, 300)
        }
      })
    },
    handleClose () {
      this.showModal = false
    }
  }
}
</script>
<style lang="scss">
.mobile{ 
  .verify-dialog{
        transform: scale(2);
    }
}
</style>
<style lang="scss" scoped>
.verify-modal-wrapper {
  .ivu-modal {
    top: 40%;
  }

}
/deep/ .nc_wrapper {
    margin: 0 auto;

    .btn_slide {
      height: 100%;
    }

    .btn_ok {
      height: 100%;
    }
  }
  /deep/ .el-dialog__wrapper{
    top: 20%;
  }
</style>


// WEBPACK FOOTER //
// src/components/VerifyModal.vue